import { Table } from 'react-bootstrap';
import { useGetStocksQuery } from '../../slices/stocksApiSlice';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useMemo } from 'react';

const StockUniqueDates = () => {
  const { data, isLoading, error } = useGetStocksQuery();

  const stocks = useMemo(() => data?.stocks || [], [data]);

  const uniqueDates = useMemo(() => {
    return stocks.length > 0 
      ? [...new Set(stocks.map(stock => new Date(stock.date).toISOString().split('T')[0]))]
      : [];
  }, [stocks]);

  const sortedDates = useMemo(() => [...uniqueDates].sort((a, b) => new Date(a) - new Date(b)), [uniqueDates]);
  const date1 = sortedDates;
  
  return (
    <>
      <h1>Unique Stock Dates</h1>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || 'Error fetching stock dates'}</Message>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>DATE</th>
            </tr>
          </thead>
          <tbody>
            {date1.map((date, index) => (
              <tr key={index}>
                <td>{date}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default StockUniqueDates;